export default __webpack_public_path__ + "static/media/shutterstock_450970201.6616d9d7.jpg";